/* @ngInject */
function InputSelectCampaignController ($rootScope, $scope, $timeout, $stateParams, $state, Utils, CampaignService) {
  $scope.campaignOptions = []
  $scope.hasMoreOptions = false
  $scope.module = ''
  $scope.flags = {
    campaignOptions: {
      skip: 0,
      limit: 10,
      hasMoreOptions: false,
      isLoading: false,
      search: ''
    }
  }
  $scope.companyFeatures = {
    campaigns: {
      access: false
    }
  }

  const charLimit = 34
  const api = {
    _formatCampaignOptions,
    _hasMoreResults,
    _getCampaigns,
    _handleCurrentCampaign
  }

  this.getApi = () => api

  activate()

  function activate () {
    $timeout(() => {
      $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        $scope.companyFeatures.campaigns = {
          access: !!features['CAMPAIGNS.ACCESS']
        }

        if (!$scope.companyFeatures.campaigns.access) return

        api._getCampaigns(true).then(() => {
          if ($scope.currentCampaignId && !$scope.selectedCampaign) {
            api._handleCurrentCampaign()
          } else if (!$scope.selectedCampaign) {
            $scope.selectedCampaign = {
              id: null,
              value: null,
              label: ''
            }
          }
        })
      })
    }, 100, true)
  }

  $scope.$watch('currentCampaignId', (newValue) => {
    if (newValue) {
      api._handleCurrentCampaign()
    }
  })

  function _handleCurrentCampaign () {
    const campaignIds = Array.isArray($scope.currentCampaignId) ? $scope.currentCampaignId : [$scope.currentCampaignId]
    CampaignService.getAllCampaigns({
      top: 1,
      skip: 0,
      search: '',
      campaignIds
    })
      .then((response) => {
        if (response.rows && response.rows.length > 0) {
          const campaign = response.rows[0]
          $scope.selectedCampaign = {
            id: campaign.id,
            value: campaign.id,
            label: campaign.title
          }
        }
      })
  }

  $scope.onSearchCampaigns = (event) => {
    const search = event.detail?.search || ''
    $scope.flags.campaignOptions.skip = 0
    $scope.flags.campaignOptions.search = search
    $scope.campaignOptions = []
    api._getCampaigns(true)
  }

  $scope.onInfiniteCampaigns = () => {
    if (!$scope.hasMoreOptions || $scope.flags.campaignOptions.isLoading) {
      return
    }
    api._getCampaigns(false)
  }

  $scope.onChangeSelectedCampaign = (event) => {
    $scope.selectedCampaign = event?.detail?.value
    $scope.$emit('campaign-selected', $scope.selectedCampaign)
    if ($scope.onChange) {
      $scope.onChange($scope.selectedCampaign)
    }
  }

  function _getCampaigns (firstLoading) {
    const { skip, limit, search } = $scope.flags.campaignOptions
    $scope.flags.campaignOptions.isLoading = true

    return CampaignService.getAllCampaigns({
      top: limit,
      skip,
      search,
      isAvailable: true
    })
      .then(response => {
        if (firstLoading) {
          $scope.campaignOptions = api._formatCampaignOptions(response.rows)
        } else {
          $scope.campaignOptions = $scope.campaignOptions.concat(api._formatCampaignOptions(response.rows))
        }

        $scope.hasMoreOptions = api._hasMoreResults(response.count, $scope.campaignOptions.length)
        $scope.flags.campaignOptions.skip += limit
      })
      .finally(() => {
        $scope.flags.campaignOptions.isLoading = false
      })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }
    return totalCount > responseLength
  }

  function _formatCampaignOptions (campaigns) {
    return campaigns.map(campaign => ({
      id: campaign.id,
      value: campaign.id,
      label: Utils.truncateText(campaign.title, charLimit),
      info: campaign
    }))
  }
}
export { InputSelectCampaignController }
